import {
    DELETE_CLIP_REQUEST_OPEN_MODAL,
    DELETE_CLIP_REQUEST_REQUEST,
    DELETE_CLIP_REQUEST_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    clipRequest: null
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case DELETE_CLIP_REQUEST_OPEN_MODAL:
            return { ...state, openModal: true, clipRequest: action.payload }

        case DELETE_CLIP_REQUEST_REQUEST:
            return { ...state, loading: true }

        case DELETE_CLIP_REQUEST_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "DELETE_CLIP_REQUEST"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};